<template>
  <div class="ProjectSidebarLayout app-sidebar-menu" :class="{ 'mt-0': $vuetify.display.smAndDown }">
    <div
      v-for="(item, i) in items"
      :key="item.key || `item_${i}`"
      class="ProjectSidebarLayout__entry"
    >
      <v-divider
        v-if="item.title === 'separator'"
        class="ProjectSidebarLayout__divider my-1 text-grey-100"
        style="opacity: 1;"
      />
      <slot v-else name="section" :item="item">
        <component
          :is="item.customComponent"
          v-if="item.customComponent"
          :item="item"
        />
        <AppSidebarItem
          v-else
          :item="toSidebarItem(item)"
          :icon-only="mini"
          @select="onSelectItem(item)"
        />
      </slot>
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex'

import AppSidebarItem from '@/common/app-sidebar/AppSidebarItem.vue'
import { ROOMS_ROUTE_NAME } from '@/router/routerData'
import { GlobalMutationTypes } from '@/store/modules/global/mutation_types'

export default {
  name: 'ProjectSidebarLayout',
  components: { AppSidebarItem },
  props: {
    items: {
      type: Array,
      required: true,
    },
  },
  computed: {
    ...mapState('global', ['mini']),
    ...mapState('room', ['currentRoom']),
  },
  methods: {
    ...mapMutations('global', [GlobalMutationTypes.SET_TOGGLE_PROJECT_DRAWER]),
    toSidebarItem (item) {
      return {
        key: item.key,
        label: item.title,
        icon: item.icon,
        iconType: 'material',
        kind: 'nav',
        active: this.isItemActive(item.key),
        dataLocator: item.locatorValue,
      }
    },
    isItemActive (routeName) {
      if (!this.currentRoom || !routeName) {
        return false
      }

      return this.$route.name === routeName ||
        this.$route.matched?.some(route => route.name === routeName)
    },
    onSelectItem (item) {
      if (item.key && this.$route.name !== item.key) {
        this.$router.push({ name: item.key })
      }

      if (this.$vuetify.display.mobile && item.key === ROOMS_ROUTE_NAME) {
        this.SET_TOGGLE_PROJECT_DRAWER(false)
      }

      if (item.action) {
        item.action()
      }
    },
  },
}
</script>

<style scoped lang="scss">
.ProjectSidebarLayout {
  &__entry {
    margin: 0;
    padding: 0;
  }

  &__divider {
    margin-inline: 8px;
  }
}
</style>
